import type { ReactNode } from 'react';
import { DemoNotice } from './demo-notice.tsx';
import { FounderContactLine } from './founder-contact.tsx';

export default function AuthShell({
  title,
  subtitle,
  children,
  wide,
  compact,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  /** Wider card, for forms whose content (e.g. the service-mode cards) needs the room. */
  wide?: boolean;
  /**
   * Less space above the card on a phone, for a page whose last important
   * control has to fit above the fold (sign-in's "Create a new account").
   */
  compact?: boolean;
}) {
  return (
    <div className="min-h-screen bg-[color:var(--color-surface)]">
      {/* Above the sign-in and registration forms, because whether this is a
          demo is something to know *before* creating an account on it. */}
      <DemoNotice />
      <div className={`flex min-h-screen items-center justify-center px-4 ${compact ? 'py-6 sm:py-12' : 'py-12'}`}>
        <main className={`w-full ${wide ? 'max-w-lg' : 'max-w-md'}`}>
          <img
            src="/BlastoClean-Logo.svg"
            alt="BlastoClean"
            className={`mx-auto h-10 w-auto ${compact ? 'mb-4 sm:mb-6' : 'mb-6'}`}
          />
          <div className="card">
            <h1 className="text-2xl font-bold">{title}</h1>
            {subtitle ? (
              <p className="mb-6 mt-1 text-[color:var(--color-muted)]">{subtitle}</p>
            ) : (
              <div className="mb-6" />
            )}
            {children}
          </div>
          {/* Under the card, not inside the form: a person creating an account
              or signing back in can reach the founder without the line
              competing with the fields. */}
          <FounderContactLine className="mt-4 text-center text-sm text-[color:var(--color-muted)]" />
        </main>
      </div>
    </div>
  );
}
